import { Tooltip } from 'react-tooltip';
import { LAYER_CONFIGS } from '../../constants/general';
import { makePrettyFromCamelCase } from '../../utils/general';

// Collect all interactive layer IDs for hover events
export const interactiveLayerIds = (visibleVectorTileLayers, layerVisibility) =>
  [
    'boundary-line',
    ...Object.keys(visibleVectorTileLayers).flatMap(layerId => [
      `${LAYER_CONFIGS[layerId]?.layerName}-fill`,
      `${LAYER_CONFIGS[layerId]?.layerName}-line-hitarea`, // Invisible wider line for easier clicking
      `${LAYER_CONFIGS[layerId]?.layerName}-line`,
      `${LAYER_CONFIGS[layerId]?.layerName}-circle`,
    ]),
    ...Object.keys(layerVisibility)
      .filter(id => layerVisibility[id] && LAYER_CONFIGS[id]?.mapType === 'geojson')
      .flatMap(id => [`${id}-fill`, `${id}-line`, `${id}-circle`, `${id}-icon`]),
  ].filter(Boolean);

export const onLayerClick = setHoverInfo => event => {
  const { features, lngLat } = event;
  const hoveredFeature = features && features[0];

  setHoverInfo(
    hoveredFeature
      ? {
          longitude: lngLat.lng,
          latitude: lngLat.lat,
          feature: hoveredFeature,
        }
      : null,
  );
};

export const formatTooltipContent = feature => {
  if (!feature || !feature.properties) return null;

  const props = feature.properties;
  const id = feature?.layer?.id.split('-')[0];
  const config = LAYER_CONFIGS[id];

  const entries = Object.entries(props).filter(
    ([key]) => !key.startsWith('_') && key !== 'id' && key !== 'state' && key !== 'index',
  );

  if (!entries.length) return null;

  const isContoursLayer = id === 'contours2ftTile';

  return (
    <div className="p-1 text-xs">
      <strong style={{ color: config?.colors.color }}>{config?.name}</strong>
      {entries.map(([key, value]) => (
        <div key={key} className="m-1">
          {key !== 'FLOOD_FREQ' ? (
            <div className="flex gap-2">
              <span className="font-semibold">{makePrettyFromCamelCase(key)}:</span>{' '}
              <p className="m-0">
                {key === 'siteUrl' ? (
                  <a href={value} target="_blank" rel="noopener noreferrer">
                    {value}
                  </a>
                ) : (
                  String(value)
                )}
                {isContoursLayer && key === 'elevation' ? ' ft' : ''}
              </p>
            </div>
          ) : (
            <span className="font-semibold">
              {value === '1' ? '100-year flood plain' : '500-year flood plain'}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export const LayerTooltip = ({ layerId, content }) => {
  return (
    <Tooltip
      id={layerId}
      place="top"
      opacity="1"
      clickable
      style={{
        background: '#F0F3F4',
        color: '#324755',
        maxWidth: '300px',
        fontSize: '14px',
        zIndex: '1000',
      }}
      border="1px solid #626262"
    >
      {content ?? LAYER_CONFIGS[layerId]?.description}
    </Tooltip>
  );
};

export const ExportTabTooltip = ({ tooltipId }) => {
  return (
    <Tooltip
      id={tooltipId}
      place="bottom"
      opacity="1"
      clickable
      style={{
        background: '#F0F3F4',
        color: '#324755',
        maxWidth: '250px',
        fontSize: '14px',
        zIndex: '1000',
      }}
      border="1px solid #626262"
    >
      County selection required to export data
    </Tooltip>
  );
};
